import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const login = async (login_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/login`,
        method: "POST",
        body: JSON.stringify(login_data),
        credentials: "include"
    });
}

export const login_via_biometric = async (bio_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/bio-login`,
        method: "POST",
        body: JSON.stringify(bio_data),
        credentials: "include"
    });
}

export const logout = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/logout`,
        method: "POST",
        credentials: "include"
    });
}

export const register = async (register_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/register`,
        method: "POST",
        body: JSON.stringify(register_data),
        credentials: "include"
    });
}

export const authorisation = async (auth_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/authorisation`,
        method: "POST",
        body: JSON.stringify(auth_data),
        credentials: "include"
    });
}

export const delete_user_account = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth`,
        method: "DELETE",
        credentials: "include"
    });
}

export const fetch_user_profile = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/profile`,
        method: "GET",
        credentials: "include"
    });
}

export const update_user_profile = async (profile_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/profile`,
        method: "POST",
        body: JSON.stringify(profile_data),
        credentials: "include"
    });
}

export const toggle_bio_status = async (bio_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/mfa/bio`,
        method: "POST",
        body: JSON.stringify(bio_data),
        credentials: "include"
    });
}

export const change_password = async (password_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/change-password`,
        method: "POST",
        body: JSON.stringify(password_data),
        credentials: "include"
    });
}

export const get_user_role = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/role`,
        method: "GET",
        credentials: "include"
    });
}

export const initiate_email_recovery = async (email_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/email/recovery`,
        method: "POST",
        body: JSON.stringify(email_data),
        credentials: "include"
    });
}

export const verify_email_recovery = async (verify_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/email/recovery/verify`,
        method: "POST",
        body: JSON.stringify(verify_data),
        credentials: "include"
    });
}

export const reset_password = async (reset_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/email/recovery/reset`,
        method: "POST",
        body: JSON.stringify(reset_data),
        credentials: "include"
    });
}

export const unlock_user_account = async (unlock_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/account/unlock`,
        method: "POST",
        body: JSON.stringify(unlock_data),
        credentials: "include"
    });
}

export const set_user_password = async (password_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/account/password`,
        method: "POST",
        body: JSON.stringify(password_data),
        credentials: "include"
    });
}

export const initiate_mfa_enrol = async (enrol_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/mfa/enrol`,
        method: "POST",
        body: JSON.stringify(enrol_data),
        credentials: "include"
    });
}

export const verify_mfa = async (verify_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/mfa/verify`,
        method: "POST",
        body: JSON.stringify(verify_data),
        credentials: "include"
    });
}

export const disable_mfa = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/auth/mfa/disable`,
        method: "POST",
        credentials: "include"
    });
}
